<template>
  <div class="container">
    <div class="cover">
      <img src="@/assets/images/cover.jpg" alt="Cover Book">
    </div>
    <h1>
        <span>Sustainable Fashion Disciple since 2001.</span>
        <span>Fashion Made with Purpose ...</span>
    </h1>
    <h2>Be mindful of your consumption, your relationship with "things" and your relationship with Earth!</h2>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'home',
  components: {
  },
  data: function() {
    return {
      title: "Kate Mack",
    }
  },
  metaInfo() { 
    const title = this.$data.title;
    const url = "https://kate-mack.com";
    const description = "Kate Mack. Wearable Art Dealer. Fashion Made Organically.";
    const preview = "https://kate-mack.com/img/preview.jpg";
    //const route = this.$route.name;
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Kate Mack',
      // all titles will be injected into this template
      titleTemplate: null,
      description: `${title} - Home`,
      meta: [
        { charset: 'utf-8' },
        { 
          name: 'keywords',
          content: 'kate-mack, Kate, Mack, kate mack, Wearable Art Dealer, art, fashion, Local Designer, Small business, Designer, Artisan, Artisan Designer'
        },
        {
          property: 'og:title',
          content: title,
          // following template options are identical
          // template: '%s - My page',
          template: chunk => `${chunk} - Home`,
          vmid: 'og:title'
        },
        { property: 'og:url', content: url, vmid: 'og:url' },
        // The list of types is available here: http://ogp.me/#types
        {property: 'og:type', content: 'website'},
        // Should the the same as your canonical link, see below.
        {property: 'og:image', content: preview},
        // Often the same as your meta description, but not always.
        {property: 'og:description', content: description},

        // Twitter card
        {name: 'twitter:card', content: description},
        {name: 'twitter:site', content: url},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description},
        // Your twitter handle, if you have one.
        {name: 'twitter:creator', content: '@KateKatemack'},
        {name: 'twitter:image:src', content: preview},

        // Google / Schema.org markup:
        {itemprop: 'name', content: title},
        {itemprop: 'description', content: description},
        {itemprop: 'image', content: preview}
      ],
      link: [
        {rel: 'canonical', href: 'https://kate-mack/'}
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
div.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  div.cover {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    a {
      align-self: flex-start;
      justify-self: flex-start;
    }
  }
  h1 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 125%;
  }
  h2 {
    font-size: 100%;
  }
  img {
    width: 400px;
    height: auto;
    max-width: 100vw;

  }
}

@media screen and (min-width: 600px) {
  div.container {
    img {
      padding: 1rem 0;
    }
  }
}
</style>
